export default "__VITE_ASSET__273b472a__"